import { mapState } from 'vuex';
import bindPhone from './bindPhone';

const authorize = {
  mixins: [bindPhone],
  data() {
    return {
      showAuthorize: false,
    };
  },
  computed: {
    ...mapState({
      detailUser: state => state.user.detailUser,
    }),
  },
  methods: {
    hideAuthorize() {
      this.showAuthorize = false;
    },
    /**
     * 判断是否打开授权弹窗
     * @param callback 回调函数
     */
    async handleShowAuthorize(callback = null) {
      if (
        this.detailUser &&
        this.detailUser.weixin &&
        this.detailUser.weixin.base &&
        this.detailUser.weixin.base.icon
      ) {
        console.log(' 已经授权头像昵称 跳过 ', this.detailUser.weixin.base);
        callback && callback();
      } else {
        console.log(' 没有头像授权昵称 ');
        this.showAuthorize = true;
      }
    },
    /**
     * 获取用户微信信息
     * @param callback 回调函数
     * @returns {Promise<void>}
     */
    async getUserData(callback = null) {
      uni.getUserInfo({
        provider: 'weixin',
        success: async res => {
          // console.log('auth 用户微信信息：', res);
          try {
            await this.handleUpdateProfile({
              bindData: res.encryptedData,
              bindDataSign: res.iv,
            });
            console.log('授权用户微信信息成功!');
            this.showAuthorize = false;
            callback && callback();
          } catch (e) {
            console.error('授权用户微信信息失败', e);
            throw new Error(e);
          }
        },
      });
    },
  },
};
export default authorize;
